import React from 'react'
import {useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import {ToastContainer, toast} from 'react-toastify';
import { BASE_URL } from '../Config/Base';
// import loader from '../Assets/Images/Loading_icon.gif'

const FoundProfileMain = () => {
   
 useEffect(()=>{
   document.getElementById("Name").innerHTML = localStorage.getItem("username");
   document.getElementById("Email").innerHTML = localStorage.getItem("email");
 })

//  const[pop,setpop] = useState(false)

//  useEffect(() => {
//   setpop(true);
//   setTimeout(() => {
//     setpop(false);
//   }, 1000);
// }, [])
 

  function handleSubmit(e){

   e.preventDefault();

    var Current = document.getElementById("Current").value;
    
    var New = document.getElementById("New").value;
    const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 

    var Confirm = document.getElementById("Confirm").value;


    
    if(!Current){
      document.getElementById('CurrentErr').innerHTML="Enter Current Password";
    }
   
    else{
   
      document.getElementById('CurrentErr').innerHTML=" ";
    }


    if(!New){
      document.getElementById('NewErr').innerHTML="Enter New Password";
    }
   else if (password1.test(document.getElementById('New').value)===false){
    document.getElementById('NewErrA').innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
  }

   else if (New==Current){ 
    document.getElementById('NewErrB').innerHTML="This is Your Current Password";
    document.getElementById('NewErrA').innerHTML=" "; 
   document.getElementById('NewErr').innerHTML=" "; 
  }

   else{
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
   }

   if(!Confirm){
    document.getElementById('ConfirmErr').innerHTML="Enter Confirm Password";
   }
   else if(Confirm != New){
    document.getElementById('ConfirmErrA').innerHTML="Password doesn't Match";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
   else{
    document.getElementById('ConfirmErrA').innerHTML=" ";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
    
   if(Current && (password1.test(document.getElementById('New').value)===true) && (Confirm == New) &&  (Current != New)){

    const body ={

      currentPassword:Current,
      newPassword:New
    
    }
    
    // console.log(body);

    //const token = JSON.parse(localStorage.getItem('token'));
    const token = JSON.parse(localStorage.getItem('usertoken'));
    
    // console.log(token)
    

    
      axios({

        method: "POST",
        url: `${BASE_URL}/Authenticate/ChangePassword`,
        data:body,
        headers: {

          "Content-Type": "application/json" ,
          "Authorization": "Bearer " + `${token}`,
    
        }

      })

      .then((response) =>{    
        console.log(response.data);
    
        if(response.data.status === "Error"){

          toast.error("InCorrect Password")
    
        }
    
    
    
        else if(response.data.status === "Success"){
          
          alert("Password Changed Successfully!");
          // toast.success("Password Changed Successfully!", {
    
          //   position: "top-center",
    
          //   autoClose: 3200,
    
          //   hideProgressBar: false,
    
          //   closeOnClick: true,
    
          //   pauseOnHover: true,
    
          //   draggable: true,
    
          //   progress: undefined,
    
          //   className: 'toast-message'
    
          //   });
    
            setTimeout(() => {
              window.location.href="/#/"
            }, 5000);
    
    
        }
  
    
        })
    
        .catch(error => {
         console.log(error);

         alert("Failed to Change Password!")
         //toast.error("Failed")
    
        })
    
    }  

  }




  function handlechange(e){

    e.preventDefault();

    var Current = document.getElementById("Current").value;
    
    var New = document.getElementById("New").value;
    const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 

    var Confirm = document.getElementById("Confirm").value;


    
    if(!Current){
      document.getElementById('CurrentErr').innerHTML="Enter Current Password";
      document.getElementById('CurrentErrA').innerHTML=" ";
    }
    
    else{
  
      document.getElementById('CurrentErr').innerHTML=" ";
    }


    if(!New){
      document.getElementById('NewErr').innerHTML="Enter New Password";
      document.getElementById('NewErrA').innerHTML=" ";
      document.getElementById('NewErrB').innerHTML=" ";
    }
    else if (password1.test(document.getElementById('New').value)===false){
      document.getElementById('NewErrA').innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
      document.getElementById('NewErr').innerHTML=" ";
      document.getElementById('NewErrB').innerHTML=" ";
    }
  
     else if (New==Current){ 
      document.getElementById('NewErrB').innerHTML="This is Your Current Password";
      document.getElementById('NewErrA').innerHTML=" "; 
     document.getElementById('NewErr').innerHTML=" "; 
    }
  
     else{
      document.getElementById('NewErrA').innerHTML=" ";
      document.getElementById('NewErr').innerHTML=" ";
      document.getElementById('NewErrB').innerHTML=" ";
     }
  

   if(!Confirm){
    document.getElementById('ConfirmErr').innerHTML="Enter Confirm Password";
    document.getElementById('ConfirmErrA').innerHTML=" ";
   }
   else if(Confirm != New){
    document.getElementById('ConfirmErrA').innerHTML="Password doesn't Match";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
   else{
    document.getElementById('ConfirmErrA').innerHTML=" ";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
    
   
  }

 /*----Function open form----*/

 function Changeformopen(e)

 {
   e.preventDefault();
    document.getElementById("modalRegisterForm").style.display = "block";
  }
    
/*----Function close form----*/

function changeformclose()

{

  document.getElementById("CurrentErr").innerHTML=" ";
  
  document.getElementById("NewErr").innerHTML="  ";  
  document.getElementById("NewErrA").innerHTML="  ";  
  document.getElementById("ConfirmErr").innerHTML="  ";  
  document.getElementById("ConfirmErrA").innerHTML="  ";
  document.getElementById('NewErrB').innerHTML=" ";
  
  document.getElementById("form").reset();
   document.getElementById("modalRegisterForm").style.display = "none";

 }

 function hide(){

  var x = document.getElementById("Current");
  var eye = document.getElementById("pass1");

  if(x.type === "password"){

    x.type = "text";
    eye.classList.remove("fa-eye-slash")
    eye.classList.add("fa-eye")
  }

  else
  {
    x.type = "password";
    eye.classList.remove("fa-eye")
    eye.classList.add("fa-eye-slash")
  }

 }

 function hideA(){

  var x = document.getElementById("New");
  var eye = document.getElementById("pass2");

  if(x.type === "password"){

    x.type = "text";
    eye.classList.remove("fa-eye-slash")
    eye.classList.add("fa-eye")
  }

  else
  {
    x.type = "password";
    eye.classList.remove("fa-eye")
    eye.classList.add("fa-eye-slash")
  }

 }

 function hideB(){

  var x = document.getElementById("Confirm");
  var eye = document.getElementById("pass3");

  if(x.type === "password"){

    x.type = "text";
    eye.classList.remove("fa-eye-slash")
    eye.classList.add("fa-eye")
  }

  else
  {
    x.type = "password";
    eye.classList.remove("fa-eye")
    eye.classList.add("fa-eye-slash")
  }
 }
 

  return (
    <>

<div className='foundation-addmain'>
<ToastContainer
     id="toast"
     className="toastify"
     position="top-center"
     autoClose={1500}
     hideProgressBar={false}
     newestOnTop={false}
     closeOnClick
     rtl={false}
     pauseOnFocusLoss
    draggable
    pauseOnHover
   />


<div className="foundation-addgrid-layout">
<div className="foundation-addmain-top">
<div className='foundation-addmain-back'>
<Link to='/Kdp Foundation'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
</div> 
<span>Profile</span>
</div>
</div>

{/* {pop?<div className='text-center'><img src={loader} alt="loader" id='loading-Indicator'/></div>
 :null} */}

<div>
       <div className="modal-dialog" role="document">
          <div className="modal-content">

            {/* <div className="modal-header text-center">
                <h4 className="modal-title w-100 font-weight-bold">ADD USER</h4>
       
                <span aria-hidden="true">&times;</span>
              
            </div> */}


      
            <form>
              <div className="modal-body mx-3">
                  <div className="md-form mb-4">
                  <span type="text" className="form-control validate" id="Name" readOnly/>
                  </div>

                  <div className="md-form mb-2">
          
                      <span type="email"  className="form-control validate"  id="Email" readOnly/>
         
                  </div>

                  
                </div>
      
                  <div className="modal-footer d-flex justify-content-center">
                        <button className="foundation-profile-button" onClick={Changeformopen} >Change Password</button>
                  </div>

           </form>



          </div>
     </div>
</div>


<div className="foundation-profile-fade" id="modalRegisterForm" tabindex="-1" role="dialog"
  aria-hidden="true">
       <div className="modal-dialog" role="document">
          <div className="modal-content"  style={{marginTop:"165px"}}>

            <div className="modal-header text-center">
                <h4 className="modal-title w-100 font-weight-bold">CHANGE PASSWORD</h4>
                <button type="button" className="close" onClick={changeformclose}>
                <span aria-hidden="true">&times;</span>
                </button>
            </div>


      
            <form onSubmit={handleSubmit} id="form">
              <div className="modal-body mx-3">
                  <div className="md-form mb-5">
                  <div style={{display:"flex"}}>
                     <input type="Password" className="form-control validate" onKeyUp={handlechange} placeholder='Current Password' id="Current"/>
                     <span className='foundation-profile-eyeicon'><i class="fa fa-eye-slash" aria-hidden="true" onClick={hide} id="pass1"></i></span>
                     </div>
                     <span  className='error' id="CurrentErr"></span>
                
        
                  </div>

                  <div className="md-form mb-5">
                  <div style={{display:"flex"}}>
                      <input type="Password"  className="form-control validate"onKeyUp={handlechange} placeholder='New Password' id="New" />
                      <span className='foundation-profile-eyeicon'><i class="fa fa-eye-slash" aria-hidden="true" onClick={hideA} id="pass2"></i></span>
                      </div>
                      <span className='error' id="NewErr"></span>
                     <span className='error' id="NewErrA"></span>
                     <span className='error' id="NewErrB"></span>
         
                  </div>

                  <div className="md-form mb-5">
                  <div style={{display:"flex"}}>
                      <input type="Password" className="form-control validate" onKeyUp={handlechange}  placeholder='Confirm Password'  id="Confirm"/>
                      <span className='foundation-profile-eyeicon'><i class="fa fa-eye-slash" aria-hidden="true" onClick={hideB} id="pass3"></i></span>
                      </div>
                      <span className='error' id="ConfirmErr"></span>
                     <span  className='error' id="ConfirmErrA"></span>
         
                  </div>
                        

                </div>
      
                  <div className="modal-footer d-flex justify-content-center">
                        <button className="foundation-adduser-button" >Submit</button>
                  </div>

             </form>



          </div>
     </div>
</div>

</div>

</>
  )

}

export default FoundProfileMain